import * as React from "react";
import { toast, ToastOptions } from "react-toastify";
import {
  ToastContentWrapper,
  ToastTextParagraph,
  ToastTextWrapper,
  ToastTitleHeader,
} from "src/components/shared/Toasts/Toasts.components";
import { ReactComponent as CloseIcon } from "src/images/toast-close-icon.svg";
import { ReactComponent as ErrorIcon } from "src/images/toast-error-icon.svg";
import { ReactComponent as SuccessIcon } from "src/images/toast-success-icon.svg";
import { ReactComponent as WarningIcon } from "src/images/toast-warning-icon.svg";

export type ToastType = "error" | "warning" | "success";

interface Props {
  message: string;
  type: ToastType;
}

const Toast: React.FunctionComponent<Props> = ({ message, type }) => {
  const renderIcon = (type: ToastType) => {
    switch (type) {
      case "error":
        return <ErrorIcon className="toastIcon" />;
      case "warning":
        return <WarningIcon className="toastIcon" />;
      case "success":
        return <SuccessIcon className="toastIcon" />;
      default:
        return <></>;
    }
  };

  const renderTitle = (type: ToastType) => {
    switch (type) {
      case "error":
        return "Error";
      case "warning":
        return "Warning";
      case "success":
        return "Success";
      default:
        return "";
    }
  };

  return (
    <ToastContentWrapper>
      {renderIcon(type)}
      <ToastTextWrapper>
        <ToastTitleHeader>{renderTitle(type)}</ToastTitleHeader>
        <ToastTextParagraph>{message}</ToastTextParagraph>
      </ToastTextWrapper>
      <CloseIcon />
    </ToastContentWrapper>
  );
};

const toastOptions: ToastOptions = {
  autoClose: 5000,
};

export const displayErrorToast = (message: string, toastId?: string) => {
  toast.error(<Toast type="error" message={message} />, {
    toastId,
    ...toastOptions,
  });
};

export const displayWarningToast = (message: string, toastId?: string) => {
  toast.warning(<Toast type="warning" message={message} />, {
    toastId,
    ...toastOptions,
  });
};

export const displaySuccessToast = (message: string, toastId?: string) => {
  toast.success(<Toast type="success" message={message} />, {
    toastId,
    ...toastOptions,
  });
};
